import {
  tNativeBillingTypes,
  ResourcesState, tNativeBankAccountTypes
} from '@/store/interfaces/resources';

import { GetterTree, ActionTree, MutationTree } from 'vuex';
import resources from '@/store/types/resources';
import { AxiosError, AxiosResponse } from 'axios';
import { bankAccountType, billingType } from '@/util/transformString/translationsDecorator';
import { http } from '@/util/HTTP';
import { allowAny } from 'teip-components';

const namespaced = true;

const initialState = (): ResourcesState => {
  return {
    bankAccountTypes: [],
    billingTypes: [],
  };
};

const state: ResourcesState = initialState();

const getters: GetterTree<ResourcesState, allowAny> = {
  [resources.getters.GET_BANK_ACCOUNT_TYPES]: state => {
    return state.bankAccountTypes;
  },
  [resources.getters.GET_BILLING_TYPES]: state => {
    return state.billingTypes;
  },
};
const mutations: MutationTree<ResourcesState> = {
  [resources.mutations.SET_BILLING_TYPES]: (state, billing: { data: tNativeBillingTypes[] }) => {
    state.billingTypes = billing.data
      .map((bll: tNativeBillingTypes) => {
        return {
          name: billingType(bll.name),
          id: bll.name,
        };
      });
  },
  [resources.mutations.SET_BANK_ACCOUNT_TYPES]: (state, accountType: { data: tNativeBankAccountTypes[] }) => {
    state.bankAccountTypes = accountType.data
      .map((bll: tNativeBankAccountTypes) => {
        return {
          name: bankAccountType(bll.name),
          id: bll.name,
        };
      });
  },
};
const actions: ActionTree<ResourcesState, allowAny> = {
  [resources.actions.BANK_ACCOUNT_TYPES]: ({ commit, }) => {
    return new Promise((resolve, reject) => {
      http
        .get('resources/bank_account_types')
        .then((res: AxiosResponse) => {
          commit(resources.mutations.SET_BANK_ACCOUNT_TYPES, res.data);
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
  [resources.actions.BILLING_TYPES]: ({ commit, }) => {
    return new Promise((resolve, reject) => {
      http
        .get('resources/billing_types')
        .then((res: AxiosResponse) => {
          commit(resources.mutations.SET_BILLING_TYPES, res.data);
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
